<template>
  <div :id="$route.name">
    <Card :back="$route.params.Status != 'Edit'">
      <template v-slot:header>
        <h4 class="d-inline" v-if="$route.params.Status == 'Edit'">ویرایش مشتری <i class="fad fa-user-edit float-left"></i></h4>
        <h4 class="d-inline" v-else>اضافه کردن مشتـری جدیـد <i class="fad fa-user-plus float-left"></i></h4>
        <div class="headehr">
          <hr id="thread3" />
        </div>
      </template>
      <template v-slot:content>
        <tab :tab="Tablist">
          <template v-slot:content0>
            <div class="container">
              <div class="row">
                <div class="col-md-12 col-12 my-2 px-3">
                  <h4>کد بازاریـابی: {{ CodebazaryabiDefault }}</h4>
                </div>
                <div class="col-md-8 col-12 my-2 px-3">
                  <small id="LblCustomerName"> نــام مشتری</small>
                  <input type="text" id="" class="form-control" placeholder="نــام مشتری" v-model="DataAxiosInsertCustomer.ArryfildValue.CustomerName" />
                </div>

                <div class="col-md-4 col-12 my-2 px-3">
                  <small id="LblCustomerCode"> کــد مشتری</small>
                  <input type="number" id="CustCode" placeholder="کــد مشتری" class="form-control" v-model="DataAxiosInsertCustomer.ArryfildValue.CustomerCode" />
                </div>
                <div v-if="$route.params.Status == 'Edit'" class="col-md-4 col-12 my-2 px-3">
                  <small id="LblBaygani"> بایگانی</small>

                  <div class="form-control">
                    <small id="LblBaygani"> بایگانی</small>
                    <input type="checkbox" class="custom-control-input InputText" id="Baygani" v-model="DataAxiosInsertCustomer.ArryfildValue.Baygani" />
                    <label class="custom-control-label" for="Baygani"> بایگانی</label>
                  </div>
                </div>
                <div v-if="$route.params.Status == 'Edit'" class="col-md-4 col-12 my-2 px-3">
                  <small id="LblAdamPardaxtBedeh"> عدم پرداخت بدهی</small>
                  <div class="form-control">
                    <small id="LblAdamPardaxtBedeh"> عدم پرداخت بدهی</small>
                    <input type="checkbox" class="custom-control-input InputText" id="AdamPardaxtBedeh" v-model="DataAxiosInsertCustomer.ArryfildValue.AdamPardaxtBedeh" />
                    <label class="custom-control-label" for="AdamPardaxtBedeh"> عدم پرداخت بدهی</label>
                  </div>
                </div>
                <div class="col-md-4 col-12">
                  <small id="LbltblCombogrp9RaveshBazaryabi"> روش بازاریـابی</small>
                  <SearchableCombo
                    :edit="false"
                    :grp="9"
                    :code="null"
                    @ResultCombo="GetResultRaveshBazaryabi"
                    :rownumintable="3"
                    :defaultvalue="DataAxiosInsertCustomer.ArryfildValue.tblCombogrp9RaveshBazaryabi"
                    :action="'TblCrmCombo/GetComboById'"
                    :method="'POST'"
                    :idinput="'tblCombogrp9RaveshBazaryabi'"
                    :keyItem="'tblCombogrp9RaveshBazaryabi'"
                    :disabled="false"
                  >
                  </SearchableCombo>
                </div>
                <div class="col-md-4 col-12">
                  <small id="LbltblCombogrp22ManbaeMoarefi"> منبع </small>
                  <SearchableCombo
                    v-if="$store.state.renderComponentCombo"
                    :edit="false"
                    :grp="22"
                    :code="RaveshBazaryabi"
                    @ResultCombo="GetResultManbaBazaryabi"
                    :rownumintable="3"
                    :defaultvalue="DataAxiosInsertCustomer.ArryfildValue.tblCombogrp22ManbaeMoarefi"
                    :action="'TblCrmCombo/GetComboByFilter'"
                    :method="'POST'"
                    :idinput="'tblCombogrp22ManbaeMoarefi'"
                    :keyItem="'tblCombogrp22ManbaeMoarefi'"
                    :disabled="RaveshBazaryabi == null && $route.params.Status != 'Edit'"
                  >
                  </SearchableCombo>
                </div>
                <div class="col-md-4 col-12">
                  <small id="LbltblCombogrp37AxarinVazeit"> آخریــن وضعــیت </small>
                  <SearchableCombo
                    :edit="false"
                    :grp="37"
                    :code="null"
                    @ResultCombo="GetResultVaziat"
                    :rownumintable="3"
                    :defaultvalue="DataAxiosInsertCustomer.ArryfildValue.tblCombogrp37AxarinVazeit"
                    :action="'TblCrmCombo/GetComboById'"
                    :method="'POST'"
                    :idinput="'tblCombogrp37AxarinVazeit'"
                    :keyItem="'tblCombogrp37AxarinVazeit'"
                    :disabled="false"
                  >
                  </SearchableCombo>
                </div>
                <div class="col-md-4 col-12">
                  <small id="LbltblCombogrp3Group"> گروه هــدف </small>
                  <SearchableCombo
                    :edit="false"
                    :grp="3"
                    :code="null"
                    @ResultCombo="GetResultGroupHadaf"
                    :rownumintable="3"
                    :defaultvalue="DataAxiosInsertCustomer.ArryfildValue.tblCombogrp3Group"
                    :action="'TblCrmCombo/GetComboById'"
                    :method="'POST'"
                    :idinput="'tblCombogrp3Group'"
                    :keyItem="'tblCombogrp3Group'"
                    :disabled="false"
                  >
                  </SearchableCombo>
                </div>
                <div class="col-md-4 col-12">
                  <small id="LbltblCombogrp4AvalinHadafBazaryabi"> هــدف </small>
                  <SearchableCombo
                    :edit="false"
                    :grp="4"
                    :code="null"
                    @ResultCombo="GetResultHadaf"
                    :rownumintable="3"
                    :defaultvalue="DataAxiosInsertCustomer.ArryfildValue.tblCombogrp4AvalinHadafBazaryabi"
                    :action="'TblCrmCombo/GetComboById'"
                    :method="'POST'"
                    :idinput="'Hadaf'"
                    :keyItem="'Hadaf'"
                    :disabled="false"
                  >
                  </SearchableCombo>
                </div>

                <div class="col-md-4 col-12 px-3">
                  <small id="LblEmpNo"> تعداد مشتری</small>
                  <input type="number" id="" class="form-control text-left" placeholder="تعداد مشتری" v-model="DataAxiosInsertCustomer.ArryfildValue.EmpNo" />
                </div>
                <div class="col-md-4 col-12 px-3">
                  <small id="LblScore"> میزان اهمیت مشتری</small>
                  <input type="number" id="Score" class="form-control text-left" placeholder="" v-model="DataAxiosInsertCustomer.ArryfildValue.Score" />
                </div>
                <div class="col-md-4 pt-4 col-12">
                  <button v-if="$route.params.Status != 'Edit'" class="btn btn-success" @click="InsertCustomer">ثـبـت مشتــری</button>
                  <button v-if="$route.params.Status == 'Edit'" class="btn btn-success" @click="UpdateCustomer">ویرایش مشتــری</button>
                  <button v-if="$route.params.Status == 'Edit'" class="btn btn-warning mx-2" @click="OnDetail">انصراف</button>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:content1>
            <div class="row">
              <div class="col-md-4 col-12" v-if="$route.params.Status == 'Edit'">
                <small id="LbltblCombogrp35NoeMojavezYaEstandard">نوع مجوز</small>
                <SearchableCombo
                  :edit="false"
                  :grp="35"
                  :code="null"
                  @ResultCombo="GetResultNoeMojavezYaEstandard"
                  :rownumintable="3"
                  :defaultvalue="DataAxiosInsertCustomer.ArryfildValue.tblCombogrp35NoeMojavezYaEstandard"
                  :action="'TblCrmCombo/GetComboById'"
                  :method="'POST'"
                  :idinput="'tblCombogrp35NoeMojavezYaEstandard'"
                  :keyItem="'tblCombogrp35NoeMojavezYaEstandard'"
                  :disabled="false"
                >
                </SearchableCombo>
              </div>
              <!-- <div class="col-md-4 col-12" v-if="$route.params.Status == 'Edit'">
                <small id="LblCodeEghtesadi"> کد اقتصادی</small>
                <input type="text" id="CodeEghtesadi" class="form-control text-left" dir="ltr" v-model="DataAxiosInsertCustomer.ArryfildValue.CodeEghtesadi" rows="1" />
              </div> -->
              <!-- <div class="col-md-4 col-12" v-if="$route.params.Status == 'Edit'">
                <small id="LblCodeMeli">شماره ثبت/شماره ملی</small>
                <input type="text" id="CodeMeli" class="form-control text-left" dir="ltr" v-model="DataAxiosInsertCustomer.ArryfildValue.CodeMeli" rows="1" />
              </div> -->
              <div class="col-md-4 col-12" v-if="$route.params.Status == 'Edit'">
                <small id="LbltblCombogrp13OldSys">سیستم قبلی</small>
                <SearchableCombo
                  :edit="false"
                  :grp="13"
                  :code="null"
                  @ResultCombo="GetResultOldSys"
                  :rownumintable="3"
                  :defaultvalue="DataAxiosInsertCustomer.ArryfildValue.tblCombogrp13OldSys"
                  :action="'TblCrmCombo/GetComboById'"
                  :method="'POST'"
                  :idinput="'tblCombogrp13OldSys'"
                  :keyItem="'tblCombogrp13OldSys'"
                  :disabled="false"
                >
                </SearchableCombo>
              </div>
              <div class="col-md-4 col-12" v-if="$route.params.Status == 'Edit'">
                <small id="LbltblUserIdRabetForosh"> رابط فروش </small>
                <SearchableCombo
                  :edit="false"
                  :grp="0"
                  :code="null"
                  @ResultCombo="GetRabetForosh"
                  :rownumintable="3"
                  :defaultvalue="DataAxiosInsertCustomer.ArryfildValue.tblUserIdRabetForosh"
                  :action="'TblCrmCombo/GetUserDatails'"
                  :method="'POST'"
                  :idinput="'tblUserIdRabetForosh'"
                  :keyItem="'tblUserIdRabetForosh'"
                  :disabled="false"
                >
                </SearchableCombo>
              </div>
              <div class="col-md-4 col-12" v-if="$route.params.Status == 'Edit'">
                <small id="LbltblUserIdRabetPoshtibani"> رابط پشتیبانی </small>
                <SearchableCombo
                  :edit="false"
                  :grp="0"
                  :code="null"
                  @ResultCombo="GetRabetPoshtibani"
                  :rownumintable="3"
                  :defaultvalue="DataAxiosInsertCustomer.ArryfildValue.tblUserIdRabetPoshtibani"
                  :action="'TblCrmCombo/GetUserDatails'"
                  :method="'POST'"
                  :idinput="'tblUserIdRabetPoshtibani'"
                  :keyItem="'tblUserIdRabetPoshtibani'"
                  :disabled="false"
                >
                </SearchableCombo>
              </div>
              <div class="col-md-4 col-12" v-if="$route.params.Status == 'Edit'">
                <small id="LblWebSite"> وبسایت</small>
                <input type="text" id="CustCode" placeholder="وبسایت" class="form-control" v-model="DataAxiosInsertCustomer.ArryfildValue.WebSite" />
              </div>
              <div class="col-md-4 col-12" v-if="$route.params.Status == 'Edit'">
                <small id="LbltblComboGrpId5Success"> علت موفقیت</small>
                <SearchableCombo
                  :edit="false"
                  :grp="5"
                  :code="null"
                  @ResultCombo="GetResultSuccess"
                  :rownumintable="3"
                  :defaultvalue="DataAxiosInsertCustomer.ArryfildValue.tblComboGrpId5Success"
                  :action="'TblCrmCombo/GetComboById'"
                  :method="'POST'"
                  :idinput="'tblComboGrpId5Success'"
                  :keyItem="'tblComboGrpId5Success'"
                  :disabled="false"
                >
                </SearchableCombo>
              </div>
              <div class="col-md-8 col-12" v-if="$route.params.Status == 'Edit'">
                <small id="LblDesSuccess">توضیحات علت موفقیت </small>
                <textarea class="form-control" v-model="DataAxiosInsertCustomer.ArryfildValue.DesSuccess" rows="1"></textarea>
              </div>
              <div class="col-md-4 col-12" v-if="$route.params.Status == 'Edit'">
                <small id="LbltblComboGrpId6UnSuccess"> علت عدم موفقیت</small>
                <SearchableCombo
                  :edit="false"
                  :grp="6"
                  :code="null"
                  @ResultCombo="GetResultUnSuccess"
                  :rownumintable="3"
                  :defaultvalue="DataAxiosInsertCustomer.ArryfildValue.tblComboGrpId6UnSuccess"
                  :action="'TblCrmCombo/GetComboById'"
                  :method="'POST'"
                  :idinput="'tblComboGrpId6UnSuccess'"
                  :keyItem="'tblComboGrpId6UnSuccess'"
                  :disabled="false"
                >
                </SearchableCombo>
              </div>
              <div class="col-md-8 col-12" v-if="$route.params.Status == 'Edit'">
                <small id="LblDesUnSuccess">توضیحات علت عدم موفقیت</small>
                <textarea class="form-control" v-model="DataAxiosInsertCustomer.ArryfildValue.DesUnSuccess" rows="1"></textarea>
              </div>

              <div class="col-12">
                <small id="LblDesCustomer"> توضیحات بیشتر</small>
                <textarea class="form-control" v-model="DataAxiosInsertCustomer.ArryfildValue.DesCustomer" rows="10"></textarea>
              </div>
              <div class="col-md-4 pt-4 col-12">
                <button v-if="$route.params.Status == 'Edit'" class="btn btn-success" @click="UpdateCustomer">ویرایش مشتــری</button>
                <button v-if="$route.params.Status == 'Edit'" class="btn btn-warning mx-2" @click="OnDetail">انصراف</button>
              </div>
            </div>
          </template>
        </tab>
      </template>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import Tab from '@/components/Tab/Tab.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import SearchableCombo1 from '@/components/Combo/SearchableCombo.vue'
import Address from './Components/Address.vue'
export default {
  data() {
    return {
      Tablist: [{ header: 'مشخصات مشتری' }, { header: 'اطلاعات تکمیلی' }],
      RaveshBazaryabi: null,
      Manba: null,
      CodebazaryabiDefault: 0,
      DataAxiosInsertCustomer: {
        Action: 'TblCustomerCrm/AddCustomer',
        Method: 'POST',
        ArryfildValue: {
          Id: 67,
          CustomerName: '',
          CustomerCode: null,
          CodeBazaryabi: Number(this.CodebazaryabiDefault),
          tblCombogrp9RaveshBazaryabi: null,
          tblCombogrp22ManbaeMoarefi: null,
          tblCombogrp37AxarinVazeit: null,
          CodeMeli: null,
          CodeEghtesadi: null,
          tblUserGrpIdInsert: 0,
          tblUserGrpIdLastEdit: 0,
        },
      },
      DataAxiosInsertAddress: {
        Action: 'TblCustomerAddress/Add',
        Method: 'POST',
        ArryfildValue: { Id: 67, CustomerName: '', CustomerCode: null, CodeBazaryabi: Number(this.CodebazaryabiDefault), tblCombogrp9RaveshBazaryabi: null, tblCombogrp22ManbaeMoarefi: null, tblCombogrp37AxarinVazeit: null, tblUserGrpIdLastEdit: 1 },
      },
      Address: [],
      tempAddress: {},
      DataAxios: {},
    }
  },
  components: { Card, Tab, SearchableCombo, SearchableCombo1, Address },
  methods: {
    GetResultRaveshBazaryabi(data) {
      this.RaveshBazaryabi = data.id
      this.DataAxiosInsertCustomer.ArryfildValue.tblCombogrp9RaveshBazaryabi = data.id
      this.$store.state.renderComponentCombo = false
      this.$nextTick(() => {
        this.$store.state.renderComponentCombo = true
      })
    },
    GetResultManbaBazaryabi(data) {
      this.DataAxiosInsertCustomer.ArryfildValue.tblCombogrp22ManbaeMoarefi = data.id
    },
    GetResultHadaf(data) {
      this.DataAxiosInsertCustomer.ArryfildValue.tblCombogrp4AvalinHadafBazaryabi = data.id
    },
    GetResultGroupHadaf(data) {
      this.DataAxiosInsertCustomer.ArryfildValue.tblCombogrp3Group = data.id
    },
    GetRabetPoshtibani(data) {
      this.DataAxiosInsertCustomer.ArryfildValue.tblUserIdRabetPoshtibani = data.id
    },
    GetRabetForosh(data) {
      this.DataAxiosInsertCustomer.ArryfildValue.tblUserIdRabetForosh = data.id
    },
    GetResultVaziat(data) {
      this.DataAxiosInsertCustomer.ArryfildValue.tblCombogrp37AxarinVazeit = data.id
    },
    GetResultUnSuccess(data) {
      this.DataAxiosInsertCustomer.ArryfildValue.tblComboGrpId6UnSuccess = data.id
    },
    GetResultOldSys(data) {
      this.DataAxiosInsertCustomer.ArryfildValue.tblCombogrp13OldSys = data.id
    },
    GetResultNoeMojavezYaEstandard(data) {
      this.DataAxiosInsertCustomer.ArryfildValue.tblCombogrp35NoeMojavezYaEstandard = data.id
    },
    GetResultSuccess(data) {
      this.DataAxiosInsertCustomer.ArryfildValue.tblComboGrpId5Success = data.id
    },
    GetCodeBazayabi() {
      var DataAxios_bazaryabi = { Action: 'TblCustomerCrm/GetBazarYabiCode', mehod: 'Get', ArryfildValue: null }
      this.$PostData(DataAxios_bazaryabi).then((result) => {
        this.CodebazaryabiDefault = result + 1
      })
    },
    InsertCustomer() {
      this.DataAxiosInsertCustomer.ArryfildValue.CodeBazaryabi = Number(this.CodebazaryabiDefault)
      this.$PostData(this.DataAxiosInsertCustomer).then((result) => {
        if (result.status == 'success') {
          this.$store.state.GetCostomerProduct = []
          this.$mySweetDefaultTost('عملیات موفق', 'مشتری جدید با موفقیت ثبت شد', 'success', 2000)
          this.$FindeCustomerById('DetailCustomer', result.userId, false, null)
        }
      })
    },
    UpdateCustomer() {
      this.DataAxiosInsertCustomer.Action = 'TblCustomerCrm/UpdateCustomer'
      this.$PostData(this.DataAxiosInsertCustomer).then((result) => {
        if (result.status == 'success') {
          this.$SetLog(this.DataAxiosInsertCustomer.ArryfildValue, 0, 0, null, 'مشتری')
          this.$mySweetDefaultTost('عملیات موفق', 'مشتری با موفقیت ویرایش شد', 'success', 2000)

          this.$FindeCustomerById('DetailCustomer', this.$route.params.Customer.Id, false, null)
        }
      })
    },
    OnDetail() {
      this.$FindeCustomerById('DetailCustomer', this.$route.params.Customer.Id, false, null)
    },
    InsertAddress(customerId) {
      this.Address.forEach((element) => {
        element.tblCustomerId = customerId
      })
      this.DataAxiosInsertAddress.ArryfildValue = this.Address
      this.$PostData(this.DataAxiosInsertAddress).then((result) => {
        if (result.status == 'success') {
          this.$mySweetDefaultTost('عملیات موفق', 'ادرسها ثبت شدند', 'success', 2000)
        }
      })
    },
    GetResultState(data) {
      var index = Number(data.key.replace('State', ''))
      this.Address[index].tblCombogrp10state = data.id
      this.Address[index].rendergrid = false
      this.$nextTick(() => {
        this.Address[index].rendergrid = true
      })
    },
    GetResultCity(data) {
      var index = Number(data.key.replace('City', ''))
      this.Address[index].tblCombogrp11Shahr = data.id
    },
  },
  created() {
    if (this.$route.params.Status == 'Edit') {
      this.$store.state.OldDataForLog = JSON.stringify(this.$route.params.Customer)
      this.DataAxiosInsertCustomer.ArryfildValue = this.$route.params.Customer
      this.CodebazaryabiDefault = this.$route.params.Customer.CodeBazaryabi
    } else {
      this.GetCodeBazayabi()
    }
  },
  mounted() {
    if (this.$route.params.Status != 'Edit') {
      this.DataAxiosInsertCustomer.ArryfildValue.tblUserGrpIdInsert = this.$session.get('UserInfo').tblUserGrpId
    } else {
      this.DataAxiosInsertCustomer.ArryfildValue.tblUserGrpIdLastEdit = this.$session.get('UserInfo').tblUserGrpId
    }
  },
}
</script>
<style scoped>
a {
  text-decoration: none !important;
}
.border.Rounded {
  background: var(--sidebar-bg-color);
}
</style>
